<template>
  <div class="full-screen" style="z-index: 1">
    <div id="downloadTip" class="header row fixed-top" v-if="showDownTip">
      <span class="btn" href="#" @click="closeDownloadTip"></span>
      <span><img src="../../assets/img/logo.png"></span>
      <div class="flex cc">
        <span class="f14">海量未删减高品质漫画</span>
      </div>
      <p class="cc"><a class="cc" id="downloadBtn">{{downloadTitle}}</a></p>
    </div>

    <div id="scroll-div-home" class="scroll-list" style="height: calc(100% - 50px);">
      <div>
        <swiper :ad-list="pageInfo.adList"></swiper>
      </div>
      <div class="search-word">
        <button @click="toBookSearch">搜索</button>
      </div>
      <div class="main">
        <books-small :title="'露露推荐'" :books="pageInfo.recommendList" v-on:show-more="toRecommend"></books-small>
        <books-small v-show="threeDList.length>0" :title="'真空出境'" :books="threeDList" v-on:show-more="toThreeD"></books-small>
        <books-small :title="'每日更新'" :books="pageInfo.updateList" v-on:show-more="toUpdate"></books-small>
        <books-small :title="'新书速递'" :books="pageInfo.newOnList" v-on:show-more="toNewOn"></books-small>
        <books-full :title="'露露重磅'" :books="pageInfo.kkbgList" v-on:show-more="toKkbg"></books-full>
        <books-large :title="'人气榜单'" :books="pageInfo.hotList" @show-more="toRanked"></books-large>
        <books-small v-if="historyList.length > 0" :title="'最近阅读'" :books="historyList"
                     @show-more="toRecent"></books-small>
      </div>
    </div>
    <a ref="homeReportUrl" class="fixed-ts" style="z-index: 10"><span>投诉</span></a>
    <bottom></bottom>

    <div id="addScreenContainer" class="add-icon">
      <div class="dialog-bottom row">
        <div class="dialog-down"></div>
        <span class="cc">请点击</span>
        <span class="cc"><img class="img" src="../../assets/img/icon-20.png"></span>
        <span class="cc">然后点击“添加到主屏幕”</span>
      </div>
      <div class="dialog-mask" @click="hideAddContainer"></div>
    </div>
    <div id="payBackConfirm-modal" v-show="payBackConfirm" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>是否支付成功？</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="showPaySuccessAlert">是</button>
          <button class="btn" type="button" @click="showPayFailAlert">否</button>
        </div>
      </div>
    </div>
    <div id="paySuccess-modal" v-show="paySuccessAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <div class="find-success">
          <h3>
            请记住永久域名
            <a href="javascript:void(0);" @click="copyUrl('llmhuu.com')" style="color: #c32900; display: block;">
              <u>llmhuu.com</u>
            </a>
            <span v-if="inAndroidApp || inAndroidBrowser">或</span>
            <a v-if="inAndroidApp || inAndroidBrowser" ref="appDownloadA3" style="color: #c32900; display: block;">
              <u>下载最新APP</u>
            </a>
            防止账号丢失!
          </h3>
          <div class="find-success">
            <p>请<font color="red">截图您的账号密码</font>或<font color="red">绑定手机号</font>！</p>
            <p>账号：<strong ref="act1"></strong></p>
            <p>密码：<strong ref="pwd1"></strong></p>
          </div>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="hidePaySuccessAlert">我已截图保存</button>
        </div>
      </div>
    </div>
    <div id="payFail-modal" v-show="payFailAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <h3>解决办法</h3>
        <div class="find-success">
          <p>1.请先截图保存当前账号密码</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;账号：<strong ref="act2"></strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;密码：<strong ref="pwd2"></strong></p>
          <p v-show="inAndroidApp" style="margin-top: 10px;">2.然后<a ref="appDownloadA1" style="color: #c32900"><u>下载最新App</u></a>或<font>默认浏览器</font>
          </p>
          <p v-show="inAndroidApp">&nbsp;&nbsp;&nbsp;打开 <span ref="appDownloadHome"></span> 进行支付</p>

          <p v-show="inAndroidBrowser" style="margin-top: 10px;">2.然后使用<font>默认浏览器</font>或<a ref="appDownloadA2"
                                                                               style="color: red"><u>下载最新App</u></a>
          </p>
          <p v-show="inAndroidBrowser">&nbsp;&nbsp;&nbsp;进行支付</p>
          <p v-show="inIos">2.然后使用<font color="red">默认浏览器Safiri</font>进行支付</p>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="hidePayFailAlert">确定</button>
        </div>
      </div>
    </div>
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>
  </div>
</template>

<script>
  import Swiper from '@/components/share/swiper'
  import BooksSmall from '@/components/share/books-small'
  import BooksLarge from '@/components/share/books-large'
  import BooksFull from '@/components/share/books-full'
  import Bottom from '@/components/layer1/bottom'

  import Recommend from '@/pages/layer2/books/recommend'

  import homeService from '../../services/homeService'
  import shelfService from "../../services/shelfService";
  import swiperService from "../../services/swiperService";
  import payService from "../../services/payService";
  import userService from "../../services/userService";
  import kkUtil from "../../assets/js/kk-util";
  import cookieUtil from "../../assets/js/cookie-util";
  import commService from "../../services/commService";
  import BooksMiddle from "../../components/share/books-middle";
  import {getReportUrl} from "../../services/urlService";
  import Alert from "../../components/share/alert";


  export default {
    name: "home",
    data() {
      return {
        payBackConfirm: false,
        paySuccessAlert: false,
        payFailAlert: false,
        inAndroidApp: false,
        inAndroidBrowser: false,
        inIos: false,
        userInfo: null,
        componentName: '',
        pageInfo: {
          adList: [],
          recommendList: [],
          newOnList: [],
          kkbgList: [],
          hotList: [],
          newList: [],
          updateList: []
        },
        threeDList: [],
        historyList: [],
        downloadTitle: '下载App',
        showDownTip: true,
        showAddTip: false,
        clientType: '',
        inBrowser: false,
        commInfo: {},
        showAlert: false,
        alertMsg: ''
      }
    },
    methods: {
      getIndexPage() {
        homeService.getIndexPage()
          .then(res => {
            let data = res.data;
            data.recommendList = data.recommendList.map(item => {
              return {
                ...item,
                showPop: true,
                popClass: {},
                popText: '推荐'
              }
            });
            data.kkbgList = data.kkbgList.map(item => {
              return {
                ...item,
                showPop: true,
                popClass: {},
                popText: '重磅'
              }
            });
            data.hotList = data.hotList.map((item, index) => {
              let i = {
                ...item,
                showPop: true,
                popText: `NO.${index + 1}`
              };
              i.popClass = {};
              i.popClass[`pop-${index}`] = true;
              return i;
            });
            this.pageInfo = data;
            swiperService.setAdList(this.pageInfo.adList);
          });
      },
      loadHistory() {
        this.historyList = shelfService.getHistory().map(item => item.bookInfo).splice(0, 3);
      },
      getThreeDList() {
        homeService.getThreeDList()
          .then(res => {
            let data = res.data;
            data = data.map(item => {
              return {
                ...item,
                showPop: true,
                popClass: {},
                popText: '真空出境'
              }
            });
            this.threeDList = data;
          });
      },
      toUpdate() {
        this.$router.isBack = false;
        this.$router.push('/home/new');
      },
      toRecommend() {
        this.$router.isBack = false;
        this.$router.push('/home/recommend');
      },
      toThreeD() {
        this.$router.isBack = false;
        this.$router.push('/home/three-d');
      },
      toKkbg() {
        this.$router.isBack = false;
        this.$router.push('/home/kkbg');
      },
      toRanked() {
        this.$router.isBack = false;
        this.$router.push('/home/ranked');
      },
      toLatest() {
        this.$router.isBack = false;
        this.$router.push('/home/latest');
      },
      toRecent() {
        this.$router.isBack = false;
        this.$router.push({path: '/shelf', query: {active: 'history'}})
      },
      toNewOn() {
        this.$router.isBack = false;
        this.$router.push({path: '/home/new-on'});
      },
      toBookSearch() {
        this.$router.isBack = true;
        this.$router.push({path: '/search'});
      },
      showDownloadTip() {
        this.inBrowser = !kkUtil.isInWebView();
        // let kkSdt = cookieUtil.getCookie("_kksdt_");
        // this.showDownTip = kkSdt == "0" ? false : true;
        this.clientType = kkUtil.getClientType();
        if (navigator.standalone) {
          this.showDownTip = false;
        } else {
          if (this.inBrowser && this.showDownTip) {
            if (this.clientType == "ios") {
              this.downloadTitle = "添加桌面";
              let dBtn = document.getElementById("downloadBtn");
              dBtn.removeAttribute("href");
              dBtn.onclick = function () {
                let container = document.getElementById("addScreenContainer");
                container.style.display = 'block';
              }
            } else if (this.clientType == "android") {
              this.downloadTitle = "下载App";
            }
          } else {
            this.showDownTip = false;
          }
        }
      },
      closeDownloadTip() {
        let downloadTip = document.getElementById("downloadTip");
        downloadTip.style.display = "none";
        cookieUtil.setCookie("_kksdt_", "0", 0);
      },
      hideAddContainer() {
        let container = document.getElementById("addScreenContainer");
        container.style.display = 'none';
      },
      showPaySuccessAlert() {
        this.payBackConfirm = false;
        this.paySuccessAlert = true;
      },
      hidePaySuccessAlert() {
        this.paySuccessAlert = false;
      },
      showPayFailAlert() {
        this.payBackConfirm = false;
        this.payFailAlert = true;
      },
      hidePayFailAlert() {
        this.payFailAlert = false;
      },
      copyUrl(url){
        (function(){
          document.oncopy = function(e){
            e.clipboardData.setData('text',url)
            e.preventDefault();
            document.oncopy = null;
          }
        })(url);
        document.execCommand('Copy');
        this.alertMsg = '复制成功';
        this.showAlert = true;
      }
    },
    components: {
      BooksMiddle,
      swiper: Swiper,
      'books-small': BooksSmall,
      'books-large': BooksLarge,
      'books-full': BooksFull,
      recommend: Recommend,
      bottom: Bottom,
      alert: Alert
    },
    mounted() {
      let $this = this;
      this.userInfo = userService.getLocalUserInfo();
      this.commInfo = commService.getLocalInitData();
      this.componentName = this.$route.name;
      console.log(this.componentName, this.$store.state.pageState[this.componentName]);
      if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('scroll-div-home');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 5);
      } else {
        this.getIndexPage();
        this.loadHistory();

        //展示真人
        const date = new Date();
        let loadThreeD = false;
        if (date.getHours() >= 21 || date.getHours() < 7) {
          loadThreeD = true;
        } else if (this.userInfo !== null && this.userInfo.recharged !==null && this.userInfo.recharged) {
          loadThreeD = true;
        }
        if (loadThreeD) {
          this.getThreeDList();
        }
      }
      this.$router.isBack = true;
      this.showDownloadTip();

      if (this.clientType == "android" && this.inBrowser) {
        setTimeout(function () {
          document.getElementById("downloadBtn").href = $this.commInfo.appDownloadUrl
        }, 1000);
      }
    },

    watch: {
      commInfo: function () {
        this.$nextTick(function () {
          //支付返回后的弹框逻辑
          if (this.userInfo != null && payService.needAlertPayWarning()) {
            if (this.clientType == "android") {
              if (this.inBrowser) {
                //安卓浏览器
                this.inAndroidBrowser = true;
              } else {
                //安卓app
                this.inAndroidApp = true;
              }
            } else {
              //iOS
              this.inIos = true;
            }
            this.payBackConfirm = true;
            this.$refs.appDownloadHome.textContent = this.commInfo.appDownloadHome;
            this.$refs.appDownloadA1.href = this.commInfo.appDownloadUrl;
            this.$refs.appDownloadA2.href = this.commInfo.appDownloadUrl;
            this.$refs.act1.textContent = this.userInfo.account;
            this.$refs.pwd1.textContent = this.userInfo.password;
            this.$refs.act2.textContent = this.userInfo.account;
            this.$refs.pwd2.textContent = this.userInfo.password;
          }
          //投诉
          if (this.userInfo == null) {
            this.$refs.homeReportUrl.href = getReportUrl(null);
          } else {
            this.$refs.homeReportUrl.href = getReportUrl(this.userInfo.account);
          }
        });
      }
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('scroll-div-home');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer1/home.vue